<template>
	<div class="parent" style="height:calc(100vh - 50px);">

		<dialogue
			:title="'Delete'"
			:paragraph="'Are you sure you want to delete Invoice '+term+'?'"
			:button_names="['Full Delete','Quickbooks Delete']"
			:show="delete_dialogue"
			v-on:dialogue="deleteInvoice"
			v-on:cancel="cancelDelete"
		></dialogue>

		<div>
			<div class="scroll" style="width:65%; height:calc(100vh - 75px); float:left;">
				<layout-3 :id=pageid1 :term=term :width=4 :height=1 style="max-height:30vh;"></layout-3>

				<layout-1 v-if="perms.includes('1')" :table_name="'Job Orders'" :id=pageid2 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'2'" :button_name="'Select'" :term=term></layout-1>
				<layout-1 v-if="perms.includes('6')" :table_name="'Job Schedules'" :id=pageid3 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'8'" :button_name="'Select'" :term=term></layout-1>
				<layout-1 v-if="perms.includes('7')" :table_name="'Documents'" :id=pageid4 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'7'" :button_name="'Select'" :term=term></layout-1>
				<layout-1 v-if="perms.includes('8')" :table_name="'TSheets'" :id=pageid5 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :term=term></layout-1>
				<layout-1 v-if="perms.includes('36')" :table_name="'Activities'" :id=pageid6 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :term=term></layout-1>

			</div>

			<div class="scroll" style="width:30%; height:calc(100vh - 75px); float:right;">
				<invoice
					ref="doc"
					:dir="'Invoice_'+parseInt(term)+'.pdf'"
					:id="parseInt(term)"
					:invoice_id="term"
					style="width:100%; height:calc(95%);">
				</invoice>
			</div>
		</div>

		<div class="nav-bar">
			<div>
				<button v-if="perms.includes('43')" v-on:click="button('Edit')">Edit Invoice</button>
				<button v-if="perms.includes('81')" v-on:click="deleteInvoiceDialogue()">Delete Invoice</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid1:PAGES.EDIT_INVOICES_PAGE,
			pageid2:PAGES.INVOICE_JOB_ORDER_PAGE,
			pageid3:PAGES.INVOICE_SCHEDULE_PAGE,
			pageid4:PAGES.INVOICE_DOCUMENT_PAGE,
			pageid5:PAGES.INVOICE_TIMESHEET_PAGE,
			pageid6:PAGES.INVOICE_ACTIVITY_PAGE,

			delete_dialogue:false,
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	methods:{
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid1,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},
		async deleteInvoiceDialogue(){
			this.delete_dialogue=true;
		},
		async cancelDelete(){
			this.delete_dialogue=false;
		},
		async deleteInvoice(buttonname){
			var fullDelete = true;
			if(buttonname != 'Full Delete'){
				fullDelete = false;
			}

			api.postData({
				type:"insert",
				data:{
					pageid:this.pageid1,
					data:[
						this.term,
						fullDelete,
					],
				}
			}).then((res) => {
				this.delete_dialogue = false;
				alert(res.data.message);
				router.go(-1);
			})
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/View_Invoices.vue